/** 服务方工作台共用的少量展示组件。颜色与圆角全部走 @hew3/shared 注入的 CSS 令牌。 */
import type { ReactNode } from 'react';

export function Card({
  title,
  sub,
  actions,
  children,
  tight,
}: {
  title?: ReactNode;
  sub?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  tight?: boolean;
}) {
  return (
    <section className={`card${tight ? ' tight' : ''}`}>
      {title !== undefined && (
        <div className="card-hd">
          <div className="card-tt">
            <span className="bar" />
            {title}
            {sub !== undefined && <small>{sub}</small>}
          </div>
          {actions !== undefined && <div>{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}

export function Kpi({
  label,
  value,
  tone,
  delta,
}: {
  label: ReactNode;
  value: ReactNode;
  tone?: 'danger' | 'warn' | 'e' | 'w';
  delta?: ReactNode;
}) {
  return (
    <div className="kpi">
      <div className="k-l">{label}</div>
      <div className={`k-v${tone ? ` ${tone}` : ''}`}>{value}</div>
      {delta !== undefined && <div className="k-d">{delta}</div>}
    </div>
  );
}

type BadgeTone = 'h' | 'e' | 'w' | 'ok' | 'warn' | 'danger' | 'ghost';

export function Badge({ tone = 'ghost', children }: { tone?: BadgeTone; children: ReactNode }) {
  return <span className={`badge ${tone}`}>{children}</span>;
}

export function PageHead({ title, sub, actions }: { title: string; sub?: string; actions?: ReactNode }) {
  return (
    <div className="page-head">
      <div className="grow">
        <div className="page-title">{title}</div>
        {sub !== undefined && <div className="page-sub">{sub}</div>}
      </div>
      {actions}
    </div>
  );
}

/** 键值对一个（详情页排版用）。 */
export function Kv({ label, value, text }: { label: string; value: ReactNode; text?: boolean }) {
  return (
    <div>
      <div className="kv-l">{label}</div>
      <div className={`kv-v${text ? ' text' : ''}`}>{value}</div>
    </div>
  );
}
